module.exports = __webpack_public_path__ + "static/media/day12.66be3e9c.jpg";